import React from 'react';

interface UploadProgressIndicatorProps {
  completedUploads: number;
  totalUploads: number;
}

const UploadProgressIndicator: React.FC<UploadProgressIndicatorProps> = ({
  completedUploads,
  totalUploads,
}) => {
  const steps = Array.from({ length: totalUploads }, (_, i) => i + 1);

  const containerStyles: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 0 25px 0',
    padding: '15px',
    gap: '8px',
    position: 'sticky',
    top: 0,
    backgroundColor: '#fff',
    zIndex: 10,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    borderRadius: '4px',
    width: '100%',
    boxSizing: 'border-box',
  };

  const stepsContainerStyles: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    flexWrap: 'wrap',
  };

  const stepBadgeStyles = (stepNumber: number): React.CSSProperties => ({
    width: '36px',
    height: '36px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '13px',
    fontWeight: 'bold',
    backgroundColor: stepNumber <= completedUploads ? '#10b981' : '#f3f4f6',
    color: stepNumber <= completedUploads ? '#fff' : '#6b7280',
    border: `2px solid ${stepNumber <= completedUploads ? '#10b981' : '#d1d5db'}`,
    transition: 'all 0.3s ease',
    flexShrink: 0,
    boxShadow: stepNumber <= completedUploads ? '0 2px 6px rgba(16, 185, 129, 0.25)' : 'none',
  });

  const lineStyles = (index: number): React.CSSProperties => ({
    width: '24px',
    height: '2px',
    backgroundColor: index < completedUploads ? '#10b981' : '#e5e7eb',
    transition: 'background-color 0.3s ease',
    margin: '0 -4px',
  });

  const completionTextStyles: React.CSSProperties = {
    fontSize: '12px',
    color: '#6b7280',
    fontWeight: 500,
    marginTop: '3px',
  };

  return (
    <div style={containerStyles}>
      <div style={stepsContainerStyles}>
        {steps.map((step) => (
          <React.Fragment key={step}>
            <div style={stepBadgeStyles(step)} title={`Upload ${step}`}>
              {step}
            </div>
            {step < totalUploads && <div style={lineStyles(step)} />}
          </React.Fragment>
        ))}
      </div>
      <div style={completionTextStyles}>
        {completedUploads} of {totalUploads} files uploaded
      </div>
    </div>
  );
};

export default UploadProgressIndicator;
